/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('UtpTestRunnerServiceApi', ($http, ApiErrorService) => {
    return {
        selectSuite: selectSuite,
        syncSuite: syncSuite,
        deselectSuite: deselectSuite,
        runTest: runTest,
        getRunningMultiTests: getRunningMultiTests,
        runMultipleTests: runMultipleTests,
        cancelMultipleTests: cancelMultipleTests,
        clearUserTestCase: clearUserTestCase,
        userSimulatorData: userSimulatorData
    };
    function selectSuite(req) {
        return $http.post(`api/UtpTestRunner/SelectSuite`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function syncSuite(userId, simId) {
        return $http.post(`api/UtpTestRunner/SyncSuite?userId=${userId}&simId=${simId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function deselectSuite(userId, simulatorId) {
        return $http.post(`api/UtpTestRunner/DeselectSuite?userId=${userId}&simulatorId=${simulatorId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function runTest(req) {
        return $http.post(`api/UtpTestRunner/RunTest`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getRunningMultiTests(userId, simId, testSuiteId) {
        return $http.get(`api/UtpTestRunner/GetRunningMultiTests?userId=${userId}&simId=${simId}&testSuiteId=${testSuiteId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function runMultipleTests(req) {
        return $http.post(`api/UtpTestRunner/RunMultipleTests`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function cancelMultipleTests(req) {
        return $http.post(`api/UtpTestRunner/CancelMultipleTests`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function clearUserTestCase(simId, userId) {
        return $http.post(`api/UtpTestRunner/ClearUserTestCase?simId=${simId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function userSimulatorData(userId, projectIterationId) {
        return $http.post(`api/UtpTestRunner/UserSimulatorData?userId=${userId}&projectIterationId=${projectIterationId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
